const rankingItems = [
  { id: 1, title: '顶流男星深夜密会神秘女子，粉丝集体破防要求解释', heat: '9.8', views: '256万', tag: '明星恋情', trend: 'up' },
  { id: 2, title: '知名带货主播产品成分造假，消费者集体维权要求赔偿', heat: '9.6', views: '231万', tag: '网红翻车', trend: 'up' },
  { id: 3, title: '热播综艺导演被曝收受选手贿赂操控比赛结果', heat: '9.4', views: '198万', tag: '综艺争议', trend: 'up' },
  { id: 4, title: '网传某演员税务问题再升级，涉事金额或达数亿元', heat: '9.1', views: '175万', tag: '税务风波', trend: 'stable' },
  { id: 5, title: '美妆品牌遭集体投诉，使用后多人出现严重过敏', heat: '8.8', views: '152万', tag: '品牌塌房', trend: 'down' },
  { id: 6, title: '直播界一哥合约到期去向成谜，各大平台争相挖角', heat: '8.5', views: '128万', tag: '直播内幕', trend: 'up' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <div className="text-center mb-10">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium bg-accent-100 text-accent-700 mb-4 whitespace-nowrap">
              <i className="ri-trophy-line"></i> 实时榜单
            </span>
            <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-3">
              黑料热度榜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto leading-relaxed">
              综合热度值实时排名，最新最热的八卦黑料一网打尽
            </p>
          </div>

          <div className="max-w-[800px] mx-auto space-y-3">
            {rankingItems.map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-xl p-5 flex items-center gap-4 md:gap-5 hover:bg-primary-50/50 transition-all duration-200 cursor-pointer"
              >
                {/* Rank number */}
                <div className="flex-shrink-0">
                  {item.id <= 3 ? (
                    <div className={`w-10 h-10 flex items-center justify-center rounded-xl font-heading text-lg font-bold ${
                      item.id === 1
                        ? 'bg-accent-500 text-background-50'
                        : item.id === 2
                          ? 'bg-primary-400 text-background-50'
                          : 'bg-secondary-400 text-background-50'
                    }`}>
                      {item.id}
                    </div>
                  ) : (
                    <span className="w-10 h-10 flex items-center justify-center text-base font-semibold text-foreground-500">
                      {item.id}
                    </span>
                  )}
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base text-foreground-900 font-medium group-hover:text-primary-600 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 mt-2 flex-wrap">
                    <span className="px-2 py-0.5 rounded-full text-xs bg-primary-100 text-primary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">
                      <i className="ri-eye-line mr-1"></i>{item.views}
                    </span>
                  </div>
                </div>

                {/* Heat */}
                <div className="flex-shrink-0 text-right">
                  <div className="flex items-center gap-1">
                    {item.trend === 'up' ? (
                      <i className="ri-arrow-up-line text-sm text-primary-500"></i>
                    ) : item.trend === 'down' ? (
                      <i className="ri-arrow-down-line text-sm text-secondary-500"></i>
                    ) : (
                      <i className="ri-subtract-line text-sm text-foreground-400"></i>
                    )}
                    <span className={`font-heading text-xl md:text-2xl font-bold ${
                      item.id <= 3 ? 'text-primary-600' : 'text-foreground-500'
                    }`}>
                      {item.heat}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">热度值</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}